export const NO_SEARCH_TERMS_SUBMITTED = 'No search terms submitted.';
